module.exports = __webpack_public_path__ + "static/media/helphubPlaceholder.ccd7642e.png";